AGADash.Stack = (function () {
    return {
        render: function (body, data) {
            AGADash.BarsAndStack.render(body, data, true);
        }
    };
})();

AGADash.Repository.register(103, AGADash.Stack);